import { createApi } from '@reduxjs/toolkit/query/react';

import { get } from 'api';
import { networkBaseQuery } from './queries';

export const prepare = (filters) => {
  const { places, topicIds, missingManager, qa, ...rest } = filters;

  let placeIds;
  if (places) {
    placeIds = JSON.parse(places).map((p) => p.value);
  }

  return {
    ...rest,
    placeIds,
    topicIds: topicIds || [],
    missingManager: missingManager ?? undefined,
    qa: qa ?? null,
  };
};

export const organizationApi = createApi({
  reducerPath: 'organizationApi',
  baseQuery: networkBaseQuery,
  tagTypes: ['subscriptions'],
  endpoints: (builder) => ({
    getOrganizationBySlug: builder.query({
      queryFn: async ({ slug, companySlug }) => {
        try {
          const response = {
            network: null,
            company: null,
          };

          response.network = (await get(`/collections/${slug}`)).data;

          if (companySlug && response.network) {
            const companyResponse = (
              await get(`/organizations/${companySlug}?collection_id=${response.network?.collection.id}`)
            ).data;
            response.company = companyResponse;
          }

          return {
            data: response,
          };
        } catch (error) {
          return { error: error.message };
        }
      },
    }),
    exportOrganizations: builder.query({
      query: ({ filters }) => ({
        url: `/organizations/export_csv`,
        params: prepare(filters),
      }),
    }),
    exportAdmins: builder.mutation({
      query: () => ({
        url: `/settings/job_board/export_admins`,
        method: 'post',
      }),
    }),
  }),
});

export const { useGetOrganizationBySlugQuery, useLazyExportOrganizationsQuery, useExportAdminsMutation } =
  organizationApi;
